﻿import { ProjectMilestoneStatus, ProjectMilestoneStatusActions } from "@/enums";

export const getActionFromStatus = (status) => {
  switch (status) {
    case ProjectMilestoneStatus.Skipped:
      return ProjectMilestoneStatusActions.Skip;
    case ProjectMilestoneStatus.Approved:
      return ProjectMilestoneStatusActions.Approve;
    case ProjectMilestoneStatus.Rejected:
      return ProjectMilestoneStatusActions.Reject;
    case ProjectMilestoneStatus.Released:
      return ProjectMilestoneStatusActions.Release;
    case ProjectMilestoneStatus.InApproval:
      return ProjectMilestoneStatusActions.SubmitForApproval;
    case ProjectMilestoneStatus.Reenable:
      return ProjectMilestoneStatusActions.Reenable;
    default:
  }
};
